import {useCallback, useState} from "react";

export type GalleryView = "closed" | "slider";

export interface UseImageGalleryReturn {
    view: GalleryView;
    activeIndex: number;
    isOpen: boolean;
    openGallery: (index?: number) => void;
    closeGallery: () => void;
    showSlider: (index: number) => void;
    setActiveIndex: (index: number) => void;
}

/**
 * Hook for managing image gallery state
 * Handles transitions between closed and slider view
 */
export function useImageGallery(): UseImageGalleryReturn {
    const [view, setView] = useState<GalleryView>("closed");
    const [activeIndex, setActiveIndex] = useState(0);

    const openGallery = useCallback((index: number = 0) => {
        setActiveIndex(index);
        setView("slider");
    }, []);

    const closeGallery = useCallback(() => {
        setView("closed");
        setActiveIndex(0);
    }, []);

    const showSlider = useCallback((index: number) => {
        setActiveIndex(index);
        setView("slider");
    }, []);

    const isOpen = view !== "closed";

    return {
        view,
        activeIndex,
        isOpen,
        openGallery,
        closeGallery,
        showSlider,
        setActiveIndex,
    };
}
